SNI.Application.addModule('recipe-video', context => {

  return {
    behaviors: ['toggle-on-message'],
    init() {
      //console.log('recipeInfo init');
    }
  };

});
